import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  setTheDashboardactions,
  setClientBranchActions,
  getSingleEmployeeActions,
  getEmployeeBranchName,
  SetDashboards,
  SettheCompletedOptions,
  SettheAllOptions,
  SettheDeclineOptions,
  setDropDownRenders,
  SetthePendingOptions,
  SettheApproveOptions,
  setAllemployeeListCounts,
  SetTheDashboardClientList,
  setZoneActions,
  setRegionActions,
  setGeoLoactionStateAction,
  SettheEmployeeAttedanceResults,
  setTheIdOne,
  setTheFROMDATELIST,
  setTheTODATELISTINDASH,
  setaRoleChnage,
  setClientBranchSearchAction,
  setTheEmployeeeStateName,
  setTheEmployeeregionName,
  setTheApproveRequeststate,
  setTheEmployeeZoneName, ///search
  settheNewDashboardRecordsActions,
  settheOnboarderdatalistedactions,
  resetOrganizationFilterlist,
  SetTheDashboardOrganizationListed,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import "../../../StyleSheet/MainComponent/DashBoard/DashBoard.scss";
///----Charts---
import { Doughnut } from "react-chartjs-2";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { Chart } from "react-google-charts";
import "react-toastify/dist/ReactToastify.css";
import ApproveIcon from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-30.svg";
import DeclineIcon from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";

import PendignIcons from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-32.svg";

import EmployeeIcons from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";
import { differenceInDays } from "date-fns"; // Using date-fns for date manipulation
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLoaderAction } from "../../../Redux/Loader";
import BarChartWithTable from "./KycBarchart";
import ChartWithTable from "./TicketCharts";
import useDebouncedEffect from "use-debounced-effect";
import { RmOnboarderpopup } from "./RmOnboarderpopup";
import dayjs from "dayjs";

const DashBoard = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const dateRangeRef = useRef(null);

  const state = useSelector((state) => state);
  const UserData = useSelector((state) => state.SideBarFiles.Role);
  const [startDateRange, setStartDate] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [nameList4, setOptions4] = useState([]);
  const [selectedValues, SetSelectValue] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  let Ids = [];
  const [Client, setClients] = useState("");
  const [clientname, setClientName] = useState();
  ////---for the percentage
  const [count, setCount] = useState(0);
  const [employeVerify, setempVer] = useState(0);
  const [declineemp, setDeclineEmp] = useState(0);
  const [PendingEmp, setPendignEmp] = useState(0);
  ////-- dispatch --- the ----- client list

  useEffect(() => {
    dispatch(setTheApproveRequeststate(6));

    dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    // dispatch(setTheEmployeeeStateName(state.ClientBranchIDs.StateName)); // just the initail values
    // dispatch(setTheEmployeeregionName(state.ClientBranchIDs.RegionName));
    // dispatch(setTheEmployeeZoneName(state.ClientBranchIDs.ZoneName));
  }, [state.ClientBranchIDs.StateName]);

  // console.log(
  //   state.ClientBranchIDs.StateName,
  //   "StateName8753847,",
  //   state.ClientBranchIDs.EmployeeListState
  // );

  /// Onboarder Table ..
  const [flattenedData, setFlattenedData] = useState([]);
  // const { sub_role } = state?.users?.userdatas;
  const { RmOnboarderdatas } = state.EmployeeVerificationsNeed;
  // console.log(sub_role ,"sub_role",state.users.userdatas);

  const [flattenedDatabool, setflattenedDatabool] = useState(() => {
    if (state.users.userdatas?.sub_role == 1 && !RmOnboarderdatas) {
      return true; // true only if RmOnboarderdatas is falsy (null/undefined/"")
    } else {
      return false; // true if RmOnboarderdatas is truthy
    }
  });

  const regionalData = useSelector(
    (state) => state.regionalMangerRecords.RegionalMangerOnboardDatas,
  );

  ///-------for the -----counts based
  const [pendingCounts, setPendingCounts] = useState(0);
  const [DeclineCounts, setDeclineCount] = useState(0);
  const [EployeeVerifiy, setEmpVerifyed] = useState(0);
  const [FindZeroticket, setFindZeroTickets] = useState(false);

  //console.log(state.DashboardCall.DashboardCLientList ,"cliesf");
  const [search, setSearch] = useState("");
  const RoleBased = useSelector((state) => state.SideBarFiles.Role);
  const [value, setValue] = useState([]);
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);

  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
    state.ClientBranchIDs.EmployeeRegion,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    state.ClientBranchIDs.EmployeeZone,
  ]);
  const [nameList5, setOptions5] = useState([]);
  const [Zone, setZone] = useState([]);

  const [datas, setData] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.ClientBranchIDs.EmployeeZone?.value,
    state: state.ClientBranchIDs.EmployeeListState?.value,
    region: state.ClientBranchIDs.EmployeeRegion?.value,
  });
  const [multiselect, setMuliselect] = useState([
    state.ClientBranchIDs.EmployeeListState,
  ]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const [TracketReport, setTicketReport] = useState({
    OpenTicket: 2,
    Closeticker: 3,
    PendingTickets: 4,
  });

  ///----Filter-----------------------

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    organization_search: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
    organization_search: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  // console.log("ghfhdgFHDGF",dcount,pcount,acount)

  // const formattedDates =
  //   selectedDates != null &&
  //   selectedDates.map((date) => {
  //     const isoString = date.toISOString();
  //     return isoString.substring(0, 10);
  //   });

  const [percentage, setPercentage] = useState({
    countforAbsent: 3,
    countforAttendances: 2,
  });

  useEffect(() => {
    if (
      state.EmployeeDashBoardAttedances.AttedanceDatas != undefined &&
      state.EmployeeDashBoardAttedances.AttedanceDatas != null
    ) {
      const Options = {
        countforAbsent:
          state.EmployeeDashBoardAttedances.AttedanceDatas
            .absent_employee_percentage,
        countforAttendances:
          state.EmployeeDashBoardAttedances.AttedanceDatas
            .present_employee_percentage,
      };
      setPercentage(Options);
    }
  }, [state.EmployeeDashBoardAttedances.AttedanceDatas]);

  // console.log(percentage, "percentage");
  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0",
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0",
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };
  const UserObjectData = useSelector((state) => state.users.UserData);

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  // var it = convert(state.EmployeeVerificationsNeed.FROMDATE);
  // var gt = convert(state.EmployeeVerificationsNeed.TODATE);
  var it = convert(today);
  var gt = convert(today);

  // console.log(it, gt);
  // state.EmployeeVerificationsNeed.FROMDATE,
  // state.EmployeeVerificationsNeed.TODATE,

  var st = convert(state.EmployeeVerificationsNeed.FROMDATE);
  var et = convert(state.EmployeeVerificationsNeed.TODATE);
  const today_day = dayjs().format("YYYY-MM-DD");

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.FROMDATE == ""
      ? // [it, gt]
        [today_day, today_day]
      : [st, et],
  );

  console.log(
    range,
    "sapdaopsidasd range",
    state.EmployeeVerificationsNeed.FROMDATE,
    state.EmployeeVerificationsNeed.TODATE,
  );

  const [Filterids, setfilterids] = useState({
    organization: state?.DashboardCall?.DashboardOrganizationSelcetdList?.value,
  });
  const [Organization_Val, setOrganization_Val] = useState(
    state?.DashboardCall?.DashboardOrganizationSelcetdList,
  );
  const [Organization_options, setOrganizations_options] = useState([]);

  ///--------------Organizations-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.organization_search,
      page_size: 20,
      page: 1,
    };
    dispatch(resetOrganizationFilterlist(payloads));
  }, [SearchedVal.organization_search]);

  useEffect(() => {
    if (state.organization_filterlist_tocall.Organization_filterlist_records) {
      let ObjectArrayFormager = [];
      ObjectArrayFormager.push({
        value: "",
        label: "ALL",
      });
      state.organization_filterlist_tocall.Organization_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.organization_name,
          });
        },
      );
      setOrganizations_options(ObjectArrayFormager);
    }
  }, [
    state.organization_filterlist_tocall.Organization_filterlist_records,
    SearchedVal.organization_search,
  ]);

  useEffect(() => {
    if (range.includes("NaN-aN-aN")) {
      setrange([]);
    } else if (range.length === 0) {
      // Do something if the list is already empty
      console.log("The list is already empty");
    }
  }, []);

  const [datestae, setdatest] = useState(false);
  // console.log(range , "73012range");
  const [datefilter, setdatefilter] = useState({
    from_date: gt,
    to_date: it,
    range: true,
  });

  // useEffect(() => {
  //   const payload = {
  //     count: 1,
  //     // from_date: datefilter.from_date,
  //     // to_date: datefilter.to_date,
  //     from_date: range[0],

  //     to_date: range[1],
  //     range: datefilter.range,
  //   };

  //   dispatch(setTheDashboardactions(payload));
  // }, []);

  const [countforAttendances, setcountforAttendancedetails] = useState(0);
  const [countforAbsent, setcountforAbsentdetails] = useState(0);
  //====monthly and yearly
  const [monthly, setmonthly] = useState(0);
  const [yearly, setyearly] = useState(0);
  const [yearlyabsent, setyearabsent] = useState(0);
  const [monthlyabsent, setmonthlyabset] = useState(0);

  const [FindZero, setFindZero] = useState(false);
  const [AttendanceZeor, setAttendanceZero] = useState(false);
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({ white_collar: "" });

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);

      if (e.value == 1) {
        dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });

        dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
        setClients("");
      } else if (e.value == 2) {
        dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

  useEffect(() => {
    if (
      !state.EmployeeVerificationsNeed.RmOnboarderdatas &&
      state.users.userdatas.sub_role != undefined &&
      state.users.userdatas.sub_role != null &&
      state.users.userdatas.sub_role &&
      state.users.userdatas.sub_role == 1
    ) {
      const zoneIds =
        state.users.userdatas?.zone_id?.map((zone) => zone.id) || [];

      if (zoneIds.length > 0) {
        const payload = {
          data: {
            site_id: zoneIds,
          },
        };
        dispatch(settheOnboarderdatalistedactions(payload));
      }
    }
  }, [state.users.userdatas]);

  useEffect(() => {
    if (regionalData && Array.isArray(regionalData)) {
      const merged = regionalData.flatMap((item) => item.data || []);

      const sortedByDays = merged.sort((a, b) => {
        const daysA = parseInt(a.days); // Remove " days" and convert to number
        const daysB = parseInt(b.days);
        return daysA - daysB;
      });

      setFlattenedData(sortedByDays);
    }
  }, [regionalData]);

  useEffect(() => {
    if (state.DashboardCall.Dashboard != null) {
      if (
        // Object.keys(state.DashboardCall.Dashboard).length
        // != 0 &&

        // state.DashboardCall.Dashboard.length != 0 &&
        state.DashboardCall.Dashboard.completed_employee_percentage == 0 &&
        state.DashboardCall.Dashboard.decline_employee_percentage == 0 &&
        state.DashboardCall.Dashboard.pending_employee_percentage == 0
      ) {
        setFindZero(true);
      } else if (
        //state.DashboardCall.Dashboard.length == 0 &&
        // Object.keys(state.DashboardCall.Dashboard).length == 0  ||
        state.DashboardCall.Dashboard.completed_employee_percentage != 0 ||
        state.DashboardCall.Dashboard.decline_employee_percentage != 0 ||
        state.DashboardCall.Dashboard.pending_employee_percentage != 0
      ) {
        setFindZero(false);
      }

      if (
        // Object.keys(state.DashboardCall.Dashboard).length
        // != 0 &&

        // state.DashboardCall.Dashboard.length != 0 &&
        state.DashboardCall.Dashboard.open_tracking_percentage == 0 &&
        state.DashboardCall.Dashboard.close_tracking_percentage == 0 &&
        state.DashboardCall.Dashboard.pending_tracking_percentage == 0
      ) {
        setFindZeroTickets(true);
      } else if (
        state.DashboardCall.Dashboard.open_tracking_percentage != 0 ||
        state.DashboardCall.Dashboard.close_tracking_percentage == 0 ||
        state.DashboardCall.Dashboard.pending_tracking_percentage != 0
      ) {
        setFindZeroTickets(false);
      }
    }

    if (
      state.EmployeeDashBoardAttedances.AttedanceDatas != null &&
      state.EmployeeDashBoardAttedances.AttedanceDatas
        .absent_employee_percentage != undefined
    ) {
      if (
        state.EmployeeDashBoardAttedances.AttedanceDatas
          .present_employee_percentage == 0 &&
        countforAttendances == 0
      ) {
        setAttendanceZero(true);
      } else if (
        state.EmployeeDashBoardAttedances.AttedanceDatas
          .present_employee_percentage != 0 ||
        state.EmployeeDashBoardAttedances.AttedanceDatas
          .absent_employee_percentage != 0
      ) {
        setAttendanceZero(false);
      }
    }
  }, [
    state.DashboardCall.Dashboard,

    state.EmployeeDashBoardAttedances.AttedanceDatas,
  ]);

  useEffect(() => {
    if (
      Client != undefined ||
      datestae ||
      (datas.state == "" && datas.region == "" && datas.zone == "")
    ) {
      setcountforAbsentdetails(0);
      setcountforAttendancedetails(0);
    }
  }, [datas, Client, datestae]);
  useEffect(() => {
    setempVer(0);
    setCount(0);
    setPendignEmp(0);
    setDeclineEmp(0);
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        client: Client,
        // count: 2,
        state: datas.state,
        region: datas.region,
        zone: datas.zone,
        // from_date: datefilter.from_date,
        // to_date: datefilter.to_date,
        from_date: range[0],

        to_date: range[1],
        range: datefilter.range,
        organization: Filterids?.organization,
      };

      setTimeout(() => {
        dispatch(setTheDashboardactions(payload));
      }, 250);

      // const payloadAttendance = {
      //   state: datas.state,
      //   region: datas.region,
      //   zone: datas.zone,
      //   from_date: range[0],
      //   to_date: range[1],
      //   range: datefilter.range,
      //   client: Client,

      //   white_collar: filterForWhite.white_collar,
      // };
      // setTimeout(() => {
      //   dispatch(SettheEmployeeAttedanceResults(payloadAttendance));
      // }, 1000);
    }
  }, [Client, datas, datefilter, range, filterForWhite, Filterids]);

  useEffect(() => {
    if (
      datas.state == "" ||
      datas.region == "" ||
      datas.zone == "" ||
      Client == ""
    ) {
      setcountforAttendancedetails(0);
      setcountforAbsentdetails(0);
    }
  }, [datas, Client, datefilter, range, filterForWhite]);

  useEffect(() => {
    if (state.DashboardCall.DashboardCLientList != null) {
      setClients(state.DashboardCall.DashboardCLientList.value);
      setClientName(state.DashboardCall.DashboardCLientList.label);
    }
  }, [state.DashboardCall.DashboardCLientList]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [datas.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  const handlOrganizationList = (selected) => {
    if (selected != null) {
      dispatch(SetTheDashboardOrganizationListed(selected));
      setOrganization_Val(selected);
      setfilterids({
        ...Filterids,
        organization: selected?.value,
      });
    } else {
      dispatch(SetTheDashboardOrganizationListed({ value: "", label: "ALL" }));
      setOrganization_Val({ value: "", label: "ALL" });
      setfilterids({
        ...Filterids,
        organization: "",
      });
    }
    setempVer(0);
    setCount(0);
    setPendignEmp(0);
    setDeclineEmp(0);
    ////counts
    setPendingCounts(0);
    setClients("");
    setClientName("");
    setEmpVerifyed(0);
    setDeclineCount(0);

    dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
  };

  const handleInputOrganization = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      organization_search: Val,
    });
  };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheEmployeeregionName(selectedVal));
      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      dispatch(setTheEmployeeZoneName(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });
      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });
    }
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        zone: "",
        region: "",
      });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));

      setClients("");

      dispatch(setTheEmployeeeStateName(selectedVal));
      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      setClients("");

      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          organization_search: SearchDebounance.organization_search,
        });
        setSearch(SearchDebounance.Clientsearch);
      }
    },
    500,
    [SearchDebounance],
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  useEffect(() => {
    if (Client == "") {
      dispatch(setAllemployeeListCounts(2));
    }
  }, []);

  // useEffect(() => {
  //   if (datestae) {
  //     setdatefilter({
  //       ...datefilter,
  //       from_date: formattedDates[0],
  //       to_date: formattedDates[1],
  //       range: true,
  //     });
  //   }
  // }, [selectedDates]);

  // console.log(selectedDates , "selectedDates");

  // console.log(datefilter, "datefilter");
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheFROMDATELIST(range[0]));
      dispatch(setTheTODATELISTINDASH(range[1]));
    }
    if (state.EmployeeVerificationsNeed.FROMDATE == "") {
      dispatch(setTheFROMDATELIST(today_day));
      dispatch(setTheTODATELISTINDASH(today_day));
    }
  }, [range]);
  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    console.log(value, "vlues");
    // if (value != null) {
    //   setrange((oldArray) => [...oldArray, d.slice(0, 10)]);
    // }

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
      // setSelectedDates(value);
      setdatest(true);
      // value.forEach((newValue) => {
      //   const tzoffset = new Date().getTimezoneOffset() * 60000;
      //   const localISOTime = new Date(newValue - tzoffset)
      //     .toISOString()
      //     .slice(0, -1);
      //   // handle the start and end dates here
      // });

      setdatefilter({
        ...datefilter,
        from_date: range[0],
        to_date: range[1],
        range: true,
      });

      // console.log(datefilter, "datefilter");
    }
  };

  const [Perecentagedata, setPercentageData] = useState({
    ///---counts  fro the  employees
    EmployeeCounts: 0,
    VerifiedEmpCount: 0,
    DeclineEmpCount: 0,
    PendingEmployeCount: 0,

    VerifiedEmp: 0,
    DeclineEmp: 0,
    PendingEmploye: 0,
  });
  useEffect(() => {
    if (
      (range.length > 0 &&
        !range.includes("NaN-aN-aN") &&
        state.DashboardCall.Dashboard != null) ||
      Object.keys(state.DashboardCall.Dashboard).length > 0
    ) {
      const optionsDatas = {
        EmployeeCounts: state.DashboardCall.Dashboard.employee_count,
        VerifiedEmpCount: state.DashboardCall.Dashboard.completed_employee,
        DeclineEmpCount: state.DashboardCall.Dashboard.decline_employee,

        PendingEmployeCount: state.DashboardCall.Dashboard.pending_employee,

        VerifiedEmp:
          state.DashboardCall.Dashboard.completed_employee_percentage,
        DeclineEmp: state.DashboardCall.Dashboard.decline_employee_percentage,
        PendingEmploye:
          state.DashboardCall.Dashboard.pending_employee_percentage,
      };

      const Options = {
        OpenTicket: state.DashboardCall.Dashboard.open_tracking_percentage,
        Closeticker: state.DashboardCall.Dashboard.close_tracking_percentage,
        PendingTickets:
          state.DashboardCall.Dashboard.pending_tracking_percentage,
      };

      setTicketReport(Options);

      setPercentageData(optionsDatas);
    } else if (
      (range.length == 0 && !range.includes("NaN-aN-aN")) ||
      state.DashboardCall.Dashboard == null ||
      Object.keys(state.DashboardCall.Dashboard).length > 0
    ) {
      const optionsDatas = {
        EmployeeCounts: 0,
        VerifiedEmpCount: 0,
        DeclineEmpCount: 0,

        PendingEmployeCount: 0,

        VerifiedEmp: 0,
        DeclineEmp: 0,
        PendingEmploye: 0,
      };
      setPercentageData(optionsDatas);

      const Options = {
        OpenTicket: 0,
        Closeticker: 0,
        PendingTickets: 0,
      };

      setTicketReport(Options);
    }
  }, [state.DashboardCall.Dashboard, range]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (state.DashboardCall.Dashboard.pending_employee_percentage != null) {
  //       setPendignEmp((prevCount) => {
  //         if (
  //           prevCount <
  //           state.DashboardCall.Dashboard.pending_employee_percentage
  //         ) {
  //           return prevCount + 1;
  //         } else {
  //           clearInterval(intervalId);
  //           return prevCount;
  //         }
  //       });
  //     }
  //   }, 100);
  //   return () => clearInterval(intervalId);
  // }, [state.DashboardCall.Dashboard.pending_employee_percentage]);

  ///---Branches------------------------------
  const data = { state: datas.state, region: datas.region, zone: datas.zone };
  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      data: data,
      organization: Filterids?.organization,
    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [search, datas, Filterids]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
            ? `${element.branch_code}-${element.client_name.toUpperCase()}`
            : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, search]);
  const HandleClientBranches = (selectedVal) => {
    //  console.log(selectedVal, "selectedvalue", counts);

    if (selectedVal != null) {
      dispatch(SetTheDashboardClientList(selectedVal));
      SetSelectValue(selectedVal);
      //  console.log("in Search");
      setClients(selectedVal.value);
      SetSelectValue(selectedVal);
      setClientName(selectedVal.label);
    } else if (selectedVal == null) {
      setempVer(0);
      setCount(0);
      setPendignEmp(0);
      setDeclineEmp(0);

      ////counts
      setPendingCounts(0);

      setEmpVerifyed(0);
      setDeclineCount(0);
      setClients("");
      SetSelectValue({ value: "", label: "ALL" });
      setClientName("");
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    }
  };
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };
  // console.log(
  //   multiselect,
  //   multiselect1,
  //   multiselect3,
  //   "128731289multiselect",
  //   multiselect[0] ? multiselect[0] : multiselect
  // );
  ///---All---Employee---List
  const HandleAllEmployees = (e) => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      if (state.ClientBranchIDs.SUBROLE != 2) {
        if (
          multiselect != undefined &&
          multiselect1 != undefined &&
          multiselect3 != undefined
        ) {
          dispatch(
            setTheEmployeeeStateName(
              multiselect[0] ? multiselect[0] : multiselect,
            ),
          );
          dispatch(
            setTheEmployeeregionName(
              multiselect1[0] ? multiselect1[0] : multiselect1,
            ),
          );

          dispatch(
            setTheEmployeeZoneName(
              multiselect3[0] ? multiselect3[0] : multiselect3,
            ),
          );
        }
        if (
          multiselect1 != undefined ||
          multiselect1 != undefined ||
          multiselect3 != undefined
        ) {
          if (multiselect == undefined) {
            dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
            dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
            dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
          }
          if (multiselect1 == undefined) {
            dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
            dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
          }
          if (multiselect3 == undefined) {
            dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
          }
        }

        dispatch(setTheFROMDATELIST(range[0]));
        dispatch(setTheTODATELISTINDASH(range[1]));
        dispatch(SetDashboards(2));

        if (state.ClientBranchIDs.DashboardIDs == 2) {
          dispatch(getEmployeeBranchName(clientname));
          navigate("/employeeVerifylist");
        }

        dispatch(getSingleEmployeeActions(Client));

        dispatch(getEmployeeBranchName(clientname));
        dispatch(SetDashboards(2));
        // dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
        // dispatch(getEmployeeEReuestlist(id.employee_request));
        //window.location.href = "/employeeVerifylist";
        dispatch(setDropDownRenders(""));
        dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
        dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed

        dispatch(SetthePendingOptions("3")); ////Pending
        dispatch(SettheDeclineOptions("4")); ///Decline
        dispatch(SettheApproveOptions("5")); //Approves

        if (state.NumberCounts.namerednder == "") {
          navigate("/employeeVerifylist");
        }
      }
    }
  };
  ///---Verified----Employees
  const HandleVerifiedemployees = () => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      if (state.ClientBranchIDs.SUBROLE != 2) {
        if (
          multiselect != undefined &&
          multiselect1 != undefined &&
          multiselect3 != undefined
        ) {
          dispatch(
            setTheEmployeeeStateName(
              multiselect[0] ? multiselect[0] : multiselect,
            ),
          );
          dispatch(
            setTheEmployeeregionName(
              multiselect1[0] ? multiselect1[0] : multiselect1,
            ),
          );

          dispatch(
            setTheEmployeeZoneName(
              multiselect3[0] ? multiselect3[0] : multiselect3,
            ),
          );
        }
        if (
          multiselect1 != undefined ||
          multiselect1 != undefined ||
          multiselect3 != undefined
        ) {
          if (multiselect == undefined) {
            dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
            dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
            dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
          }
          if (multiselect1 == undefined) {
            dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
            dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
          }
          if (multiselect3 == undefined) {
            dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
          }
        }

        dispatch(setTheFROMDATELIST(range[0]));

        dispatch(setTheTODATELISTINDASH(range[1]));
        dispatch(SetDashboards(2));

        if (Client == null || Client == undefined) {
          dispatch(SetDashboards(2));
          if (state.ClientBranchIDs.DashboardIDs == 2) {
            dispatch(getEmployeeBranchName(clientname));
            navigate("/employeeVerifylist");
          }
        }

        dispatch(getSingleEmployeeActions(Client));

        dispatch(getEmployeeBranchName(clientname));

        dispatch(SettheCompletedOptions("1")); //----set a first dropdown value completed
        dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
        dispatch(setDropDownRenders("completed"));
        if (state.NumberCounts.namerednder == "completed") {
          navigate("/employeeVerifylist");
        }
      } else if (range.length > 0 || !range.includes("NaN-aN-aN")) {
      }
    }
  };
  const HandledecineEmp = () => {
    dispatch(SetDashboards(2));
    if (state.ClientBranchIDs.SUBROLE != 2) {
      if (
        multiselect != undefined &&
        multiselect1 != undefined &&
        multiselect3 != undefined
      ) {
        dispatch(
          setTheEmployeeeStateName(
            multiselect[0] ? multiselect[0] : multiselect,
          ),
        );
        dispatch(
          setTheEmployeeregionName(
            multiselect1[0] ? multiselect1[0] : multiselect1,
          ),
        );

        dispatch(
          setTheEmployeeZoneName(
            multiselect3[0] ? multiselect3[0] : multiselect3,
          ),
        );
      }
      if (
        multiselect1 != undefined ||
        multiselect1 != undefined ||
        multiselect3 != undefined
      ) {
        if (multiselect == undefined) {
          dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
          dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
          dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
        }
        if (multiselect1 == undefined) {
          dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
          dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
        }
        if (multiselect3 == undefined) {
          dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
        }
      }

      dispatch(setTheFROMDATELIST(range[0]));
      dispatch(setTheTODATELISTINDASH(range[1]));

      if (Client == null || Client == undefined) {
        dispatch(SetDashboards(2));

        if (state.ClientBranchIDs.DashboardIDs == 2) {
          dispatch(getEmployeeBranchName(clientname));
          navigate("/employeeVerifylist");
        }
      }

      dispatch(getSingleEmployeeActions(Client));

      dispatch(getEmployeeBranchName(clientname));

      dispatch(SettheDeclineOptions("1")); //----set a first dropdown value Declined Employees
      dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
      dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed
      dispatch(setDropDownRenders("Decline"));
      if (state.NumberCounts.namerednder == "Decline") {
        navigate("/employeeVerifylist");
      }
    }
  };
  const HandlePendngEmployess = () => {
    if (state.ClientBranchIDs.SUBROLE != 2) {
      dispatch(SetDashboards(2));
      if (
        multiselect != undefined &&
        multiselect1 != undefined &&
        multiselect3 != undefined
      ) {
        dispatch(
          setTheEmployeeeStateName(
            multiselect[0] ? multiselect[0] : multiselect,
          ),
        );
        dispatch(
          setTheEmployeeregionName(
            multiselect1[0] ? multiselect1[0] : multiselect1,
          ),
        );

        dispatch(
          setTheEmployeeZoneName(
            multiselect3[0] ? multiselect3[0] : multiselect3,
          ),
        );
      }
      if (
        multiselect1 != undefined ||
        multiselect1 != undefined ||
        multiselect3 != undefined
      ) {
        if (multiselect == undefined) {
          dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
          dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
          dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
        }
        if (multiselect1 == undefined) {
          dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
          dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
        }
        if (multiselect3 == undefined) {
          dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
        }
      }

      dispatch(setTheFROMDATELIST(range[0]));
      dispatch(setTheTODATELISTINDASH(range[1]));

      if (Client == null || Client == undefined || Client == "") {
        if (state.ClientBranchIDs.DashboardIDs == 2) {
          dispatch(SetDashboards(2));
          navigate("/employeeVerifylist");
          dispatch(getSingleEmployeeActions(Client));
        }
      }

      dispatch(getSingleEmployeeActions(Client));

      dispatch(getSingleEmployeeActions(Client));
      dispatch(setDropDownRenders("Pending"));
      dispatch(getEmployeeBranchName(clientname));

      // dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
      // dispatch(getEmployeeEReuestlist(id.employee_request));
      //window.location.href = "/employeeVerifylist";
      dispatch(SetthePendingOptions("1"));
      dispatch(SettheDeclineOptions("4")); //----set a first dropdown value Declined Employees
      dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
      dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed

      if (state.NumberCounts.namerednder == "Pending") {
        navigate("/employeeVerifylist");
      }
    }
  };

  const datamonth = [
    {
      value: monthly,
      label: "Present Employees",
      color: "#1FDC0F",
    },
    {
      value: monthlyabsent,

      label: "Absent Employees",
      color: "#FF0000",
    },
  ];
  const seriesConfigdata = {
    arcLabel: (item) => `${item.value}%`,
    data: data, // Pass the 'datapie' as the 'data' prop
    // highlightScope: { faded: "global", highlighted: "item" },
    // faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
  };

  const seriesConfmonth = {
    arcLabel: (item) => `${item.value}%`,

    data: datamonth, // Pass the 'datapie' as the 'data' prop
    highlightScope: { faded: "global", highlighted: "item" },
    faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
  };

  const data4 = {
    labels: [
      // 'Red',
      // 'Blue',
      // 'Yellow'
      `${employeVerify}, ${count} , ${45},${PendingEmp}`,
    ],
    datasets: [
      {
        // label: 'My First Dataset',
        // data: [300, 50, 100],
        data: `${employeVerify}, ${count} , ${45},${PendingEmp}`,
        backgroundColor: [
          "rgb(255, 99, 132)",
          "rgb(54, 162, 235)",
          "rgb(255, 205, 86)",
          "red",
        ],
        hoverOffset: 4,
      },
    ],
  };

  const pie_chart_data_Dia = [
    ["Onboarding", "count"],
    ["Verified Employees", Perecentagedata.VerifiedEmp],
    ["Declined Employees", Perecentagedata.DeclineEmp],
    ["Pending Employees", Perecentagedata.PendingEmploye],

    // ["Samples Collected", 67],
  ];
  // console.log(pie_chart_data_Dia , "pie_chart_data_Dia");

  const options_dia = {
    title: "Onboard Details",
    pieHole: 0.5,
    is3D: false,
    slices: {
      0: { color: "#11734B" }, // Green for Verified Employees
      1: { color: "blue" }, // Blue for Declined Employees
      2: { color: "red" }, // Red for Pending Employees
    },
    titleTextStyle: {
      fontSize: 16, // Title font size

      paddingBottom: 30,
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      // width: "90%", // Adjust chart area to fit better
      // height: "80%",
      width: "90%", // Adjust chart area to fit better
      height: "80%",
      top: 50, // Adjust top margin to create space for the title
    },
  };

  const Attendancedata = [
    ["Employee Attendance", "count"],
    ["Present Employees", percentage.countforAttendances],
    ["Absent Employees", percentage.countforAbsent],

    // ["Employee Attendance", "count"],
    // ["Present Employees", 0.0],
    // ["Absent Employees", 99.89]
  ];
  console.log(percentage, "percentage");

  console.log(Attendancedata, "Attendancedata");

  const options_attendances = {
    title: "Attendance Details",
    pieHole: 0.5,
    is3D: false,
    slices: {
      //   0: { color: "lite-blue" },
      0: { color: "#1FDC0F" },
      1: { color: "#FF0000" },
    },
    sliceVisibilityThreshold: 0, // Ensure all slices are visible

    titleTextStyle: {
      fontSize: 14, // Title font size
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      width: "90%", // Adjust chart area to fit better
      height: "70%",
      top: 50,
    },
  };

  //   setInterval(() => {

  //  dispatch(setTheIdOne(3))

  //   }, 8000);

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
    // {
    //   label: "Next week",
    //   closeOverlay: false,
    //   value: (value, index) => {
    //     console.log(value);
    //     const [start = new Date()] = value[index] || [];
    //     return [
    //       addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
    //       addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
    //     ];
    //   },
    //   appearance: "default",
    // },
  ];

  ///--tcktes---

  const pie_chart_data_Ticket = [
    ["Ticket", "count"],
    ["Closed Tickets", TracketReport.Closeticker],
    ["Open Tickets", TracketReport.OpenTicket],
    ["Pending Tickets", TracketReport.PendingTickets],
  ];

  const optionsTickets_dia = {
    title: "Ticket Details",
    pieHole: 0.5,
    is3D: false,
    slices: {
      0: { color: "#11734B" }, // Green for Verified Employees
      1: { color: "blue" }, // Blue for Declined Employees
      2: { color: "red" }, // Red for Pending Employees
    },
    titleTextStyle: {
      fontSize: 14, // Title font size

      paddingBottom: 30,
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      // width: "90%", // Adjust chart area to fit better
      // height: "80%",
      width: "90%", // Adjust chart area to fit better
      height: "80%",
      top: 50, // Adjust top margin to create space for the title
    },
  };

  const disabledDate = (date) => {
    if (isAfter(date, today)) {
      return true;
    }
    if (startDateRange) {
      const maxEndDate = addDays(startDateRange, 30);
      if (isAfter(date, maxEndDate)) {
        return true;
      }
    }
    return false;
  };

  const openMe = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("left", "1120.344px", "important");
      rsAnimFade.style.setProperty("top", "186.109px", "important");
    }
  };

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("display", "none", "important");
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');
    }
  };

  const getZoomFactor = () => {
    const zoom = document.body.style.zoom;
    return zoom ? parseFloat(zoom) / 100 : 1;
  };

  const alignDateRangePicker = (pickerNode) => {
    const picker = pickerNode?.root || pickerNode?.container || pickerNode;

    const popup = document.querySelector(
      ".rs-picker-popup.rs-picker-popup-daterange",
    );

    if (!picker || !popup) return;

    const zoom = getZoomFactor();
    const rect = picker.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    const viewportWidth = window.innerWidth / zoom;
    const viewportHeight = window.innerHeight / zoom;

    const scrollX = window.scrollX / zoom;
    const scrollY = window.scrollY / zoom;

    let left = rect.right / zoom - popupWidth + scrollX;
    let top = rect.bottom / zoom + 8 + scrollY;

    if (left < 8) left = 8;
    if (left + popupWidth > viewportWidth - 8) {
      left = viewportWidth - popupWidth - 8;
    }

    if (top + popupHeight > viewportHeight + scrollY - 8) {
      top = rect.top / zoom - popupHeight - 8 + scrollY;
    }

    popup.style.position = "absolute";
    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {RoleBased != undefined ? (
              <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                RoleBased,
              )}! `}</h2>
            ) : null}
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Overview</li>
            </ul> */}
          </div>
        </div>

        {/* DatePickerdashborads */}
        <div
          className=" row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
            marginTop: "14px ",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "All" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              // isClearable={multiselect1 != null && multiselect1?.label == "ALL" || multiselect1?.label =="All" ?  false :
              //   true}
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                        multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                        multiselect3.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Organization
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                handlOrganizationList(e);
              }}
              options={Organization_options}
              labelledBy="Select"
              onInputChange={handleInputOrganization}
              isClearable={
                state?.DashboardCall?.DashboardOrganizationSelcetdList
                  ? Array.isArray(
                      state?.DashboardCall?.DashboardOrganizationSelcetdList,
                    )
                    ? state?.DashboardCall?.DashboardOrganizationSelcetdList.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : state?.DashboardCall?.DashboardOrganizationSelcetdList
                          .label === "ALL" ||
                        state?.DashboardCall?.DashboardOrganizationSelcetdList
                          .label === "All"
                      ? false
                      : true
                  : true
              }
              value={state?.DashboardCall?.DashboardOrganizationSelcetdList}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // onSelect={(e) => {
              //   if (e != null) {
              //     SetSelectValue(e);
              //     dispatch(SetTheDashboardClientList(e));
              //   }
              // }}
              filterOption={() => true}
              onChange={(e) => {
                HandleClientBranches(e);
              }}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={
                state.DashboardCall.DashboardCLientList
                  ? Array.isArray(state.DashboardCall.DashboardCLientList)
                    ? state.DashboardCall.DashboardCLientList.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : state.DashboardCall.DashboardCLientList.label === "ALL" ||
                        state.DashboardCall.DashboardCLientList.label === "All"
                      ? false
                      : true
                  : true
              }
              isDisabled={filterForWhite.white_collar ? true : false}
              // isMulti
              value={state.DashboardCall.DashboardCLientList}
            />
          </div>

          <div className="col-sm-2 SelectedDate" style={{ marginTop: "-21px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                onOpen={() => {
                  setTimeout(() => {
                    alignDateRangePicker(dateRangeRef.current);
                  }, 80);
                }}
                editable={false} // ✅ FULLY disables typing & arrow keys
                style={{
                  width: "100%",
                  padding: "0px 5px",
                }}
                ref={dateRangeRef}
                defaultValue={
                  state.EmployeeVerificationsNeed.FROMDATE == ""
                    ? [
                        // new Date(new Date().setDate(today.getDate() - 30)),
                        // new Date(),
                        // new Date(),
                        // new Date(state.EmployeeVerificationsNeed.FROMDATE),
                        // new Date(state.EmployeeVerificationsNeed.TODATE),
                        new Date(range[0]),
                        new Date(range[1]),
                      ]
                    : [
                        // new Date(new Date().setDate(today.getDate() - 30)),
                        // new Date(),
                        // new Date(),

                        new Date(state.EmployeeVerificationsNeed.FROMDATE),
                        new Date(state.EmployeeVerificationsNeed.TODATE),
                      ]
                }
                disabledDate={(date) => isAfter(date, new Date())}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                // onClean={(e) => cleaningrange(e)}
                onClean={false}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      // "validtill",
                      handlechangedate(localISOTime);
                    });
                  }

                  // if (e != null && e.length === 2) {
                  //   const [startDate, endDate] = e;
                  //   const diffDays = differenceInDays(endDate, startDate);
                  //   if (diffDays === 30) {
                  //     // Since we are using inclusive range, difference should be 30 for 31 days
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else if (diffDays < 30) {
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else {
                  //     toast.error("Please select a range of exactly 31 days.", {
                  //       position: toast.POSITION.TOP_RIGHT,
                  //     });
                  //   }
                  // }
                }}
                onSelect={(e) => {
                  if (e && e.length === 1) {
                    setStartDate(e[0]);
                  }
                }}
              />
            </div>
          </div>

          <div
            class=" field-div col-sm-2"
            style={{ zIndex: "20", marginTop: "20px" }}
          >
            <label class="form-label">Employee Designation</label>

            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                HandleEMprole(e);
              }}
              value={EMpROleSelected}
              options={EmpRoles}
              placeholder="search"
            />
          </div>
        </div>

        <br />
        <div className="row DashRows">
          <div className="col-12 mt-2">
            <h4>Onboarding Details</h4>
          </div>

          <div className="col-12">
            <div className="row DashRows DashboardOverview">
              {/* ----------------Kyc----Total----Counts---- */}
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
                onClick={HandleAllEmployees}
              >
                <div
                  className="card Dashboard01"
                  style={{
                    borderRadius: "7px",
                    border: "none",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <div className="card-Body DashboardCardBody">
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                    <div
                      className="DashICON iconsEmpVer"
                      style={{
                        background: "#234492",
                        border: "3px solid white",
                        width: "59px",
                        borderRadius: "7px",
                      }}
                    >
                      {/* <i
                          class="fa-solid fa-users-gear"
                          style={{ color: "white" }}
                        ></i> */}
                      <img src={EmployeeIcons} style={{ height: "100%" }} />
                    </div>

                    <div
                      className="Counts"
                      style={{
                        fontSize: "30px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "30px",
                          fontWeight: "900",
                        }}
                      >
                        {Perecentagedata.EmployeeCounts}
                        {/* {count} */}
                      </span>

                      <span
                        style={{ fontSize: "16px", width: "94px" }}
                        className="DashboardCardHeader"
                      >
                        Total Count
                      </span>
                    </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  style={{
                    borderRadius: "7px",
                    // height: "80px",
                    border: "none",

                    // width: "100%",
                    // width: "111%",

                    // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                    onClick={HandleVerifiedemployees}
                  >
                    <div
                      className="DashICON iconsEmpVer"
                      style={{
                        background: "#234492",
                        border: "3px solid white",
                        width: "59px",
                        borderRadius: "7px",
                      }}
                    >
                      <img src={ApproveIcon} style={{ height: "100%" }} />
                    </div>

                    <div
                      className="Counts"
                      style={{
                        fontSize: "30px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "30px",
                          fontWeight: "900",
                        }}
                      >
                        {" "}
                        {Perecentagedata.VerifiedEmpCount}
                      </span>

                      {/* {`${employeVerify}%`} */}

                      <span className="DashboardCardHeader DashboardHeaderStatus">
                        Completed
                      </span>
                    </div>
                  </div>
                </div>
                {/* 
                <div
                  class="Dash-info"
                  style={{ color: "black", textAlign: "center" }}
                >
                  <span class="text-muted"  style={{fontSize:"13px"}}>Onboarding Verified Employees </span>
                </div> */}
              </div>

              {/* ----------------------Kyc Decline----EMployees---------------- */}
              <div
                // className="col-xl-4 col-sm-6 col-12"
                // className="col-2"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  // className="card"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "88px",
                  //   width: "50%",
                  //   // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}

                  className="card Dashboard01"
                  style={{
                    borderRadius: "7px",
                    // height: "80px",
                    border: "none",

                    // width: "100%",
                    // width: "111%",

                    // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  {/* <div
                    className="card-Body"
                    style={{
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                    onClick={HandledecineEmp}
                  >
                    <div className="Dash">
                      <div className="Counts" style={{ fontSize: "30px" }}>
                        {DeclineCounts}
                      </div>
                    </div>
                  </div> */}

                  <div
                    className="card-Body DashboardCardBody"
                    onClick={HandledecineEmp}
                  >
                    <div
                      className="DashICON iconsEmpVer"
                      style={{
                        background: "#234492",
                        border: "3px solid white",
                        width: "59px",
                        borderRadius: "7px",
                      }}
                    >
                      <img src={DeclineIcon} style={{ height: "100%" }} />
                    </div>

                    <div
                      className="Counts"
                      style={{
                        fontSize: "30px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "30px",
                          fontWeight: "900",
                        }}
                      >
                        {" "}
                        {/* {DeclineCounts} */}
                        {Perecentagedata.DeclineEmpCount}
                      </span>

                      {/* {`${employeVerify}%`} */}

                      <span className="DashboardCardHeader DashboardHeaderStatus">
                        Decline{" "}
                      </span>
                    </div>
                  </div>
                </div>

                {/* <div
                  class="Dash-info"
                  style={{ color: "black", textAlign: "center" }}
                >
                  <h6 class="text-muted"> Declined Employees </h6>
                </div> */}
              </div>

              {/* ----------------------Pending----EMployees---------------- */}
              <div
                // className="col-xl-4 col-sm-6 col-12"
                // className="col-2"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  style={{
                    borderRadius: "7px",
                    // height: "80px",
                    border: "none",

                    // width: "100%",
                    // width: "111%",

                    // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                    onClick={HandlePendngEmployess}
                  >
                    <div
                      className="DashICON iconsEmpVer"
                      style={{
                        background: "#234492",
                        border: "3px solid white",
                        width: "59px",
                        borderRadius: "7px",
                      }}
                    >
                      <img src={PendignIcons} style={{ height: "100%" }} />
                    </div>

                    <div
                      className="Counts"
                      style={{
                        fontSize: "30px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "30px",
                          fontWeight: "900",
                        }}
                      >
                        {" "}
                        {/* {pendingCounts} */}
                        {Perecentagedata.PendingEmployeCount}
                      </span>

                      <span className="DashboardCardHeader DashboardHeaderStatus">
                        Pending
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="row DashRows"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: "156px",
              width: "100%",
              marginTop: "35px",
            }}
          >
            <div className="col-4">
              {!FindZero && range.length > 0 && !range.includes("NaN-aN-aN") ? (
                <>
                  <div
                    class="card"
                    style={{
                      display: "flex",
                      fontFamily: " MediumMetropolisweight !important",
                    }}
                  >
                    <Chart
                      chartType="PieChart"
                      data={pie_chart_data_Dia}
                      options={options_dia}
                      // options={{
                      //   ...options_dia,
                      //   pieSliceText: "value",
                      //   pieSliceTextStyle: {
                      //     color: "black", // text color
                      //     fontSize: 14, // text size
                      //   },
                      // }}
                      width={"400px"}
                      height={"290px"}
                      className="DashboardCardHeader"
                    />
                  </div>
                </>
              ) : (
                <div className="col-4">
                  <div
                    class="card"
                    style={{
                      display: "flex",
                      alignItems: "left",
                      justifyContent: "left",
                      // height: "299px",
                      height: "100%",
                      width: "425px",
                      fontFamily: " MediumMetropolisweight !important",
                    }}
                  >
                    <div className="card">
                      <div className="DashboardCHART">
                        <h3
                          style={{ fontWeight: "900" }}
                          className="DashboardCardHeader"
                        >
                          Onboard Details
                        </h3>
                        <p className="DashboardCardHeader Nodatas">
                          No data available
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-4">
              {!FindZeroticket &&
              range.length > 0 &&
              !range.includes("NaN-aN-aN") ? (
                <div class="card">
                  <Chart
                    chartType="PieChart"
                    data={pie_chart_data_Ticket}
                    options={optionsTickets_dia}
                    // options={{
                    //   ...optionsTickets_dia,
                    //   pieSliceText: "value",
                    //   pieSliceTextStyle: {
                    //     color: "black", // text color
                    //     fontSize: 14, // text size
                    //   },
                    // }}
                    width={"400px"}
                    height={"290px"}
                  />
                </div>
              ) : (
                <div class="card">
                  <div className="DashboardCHART">
                    <h3
                      style={{ fontWeight: "900" }}
                      className="DashboardCardHeader"
                    >
                      Tickets Details
                    </h3>
                    <p className="DashboardCardHeader Nodatas">
                      {" "}
                      No data available
                    </p>{" "}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {flattenedDatabool && (
        <RmOnboarderpopup
          show={flattenedDatabool}
          setshow={setflattenedDatabool}
          data={flattenedData}
        />
      )}
    </>
  );
};

export default DashBoard;
